import { Pipe, PipeTransform } from '@angular/core';

import { cidadeClassificacoes } from '../classificacao-abc';

@Pipe({
    name: 'cidadeClassificacaoAbc'
})
export class CidadeClassificacaoAbcPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = cidadeClassificacoes.findIndex(classificacao => classificacao.id === value);
        if (index > -1) {
            return cidadeClassificacoes[index].nome;
        }
        return '';
    }
}
